import fetch from '../../lib/wrappedFetch'
import config from '../../config'

class TriggersService {
  createTrigger = body => {
    return fetch(config.config.endpointUrls.createTrigger(), {
      method: 'POST',
      body
    })
  }
}

export default new TriggersService()



// WEBPACK FOOTER //
// ../src/services/triggersService/triggersService.js